import React from 'react'
import { Link } from 'gatsby'

import '../stylesheets/reset.css'
import '../stylesheets/style.css'

const About = props => {
  const bio = `Hi, I'm Sofia, a creator, graphic designer, photographer, and small business owner who believes the little details make life special. I design stationery and accessories inspired by creativity, organization, and self-expression, and I capture moments through photography that tell real, meaningful stories. Whether it's a card for someone you love, a photo that holds a memory, or a sticker that makes you smile, my goal is to create work that feels personal, fun, and meaningful`

  return (
    <div id='root' className='about'>
      <div id='nav' className='about'>
        <div id='header'>
          <Link to={'/'}>
            <h1 id='sofia'>SOFIA</h1>
            <h1 id='vidal'>VIDAL</h1>
          </Link>
        </div>
        <div id='collections' className='about-bio'>
          <p>
            { bio }
          </p>
        </div>
        <div id='collections-mobile' className='about-bio'>
          <p>
            { bio }
          </p>
        </div>
      </div>
      <div className='gallery about' style={{ overflow: 'hidden' }}>
        <div id='gallery-row'>
          <img className='full-image' src="/about-photo.png" alt="Sofia sitting on a wooden crate, holding a color checker card, with eyes peeking out playfully" />
        </div>
      </div>
    </div>
  )
}

export default About

